import { MenuItem } from '../components/menu';
import simulatorConfig from '../constants/simulator-config-constants';
import {
  imageViewerDropdownItems,
  helpDropdownItems,
  isocenterDropdownItems,
  notificationDropdownItems,
  simulatorNavDropdownActions,
  scannerSettingsDropdownItems,
  simulationSettingsDropdownItems,
  patientSettingsDropdownItems,
} from '../constants/simulator-nav-constants';

export const simulatorMenuItems: MenuItem[] = [
  {
    title: 'Patient settings',
    action: patientSettingsDropdownItems[0].action,
  },
  {
    title: 'Scanner settings',
    action: scannerSettingsDropdownItems[0].action,
  },
  {
    title: 'Simulation settings',
    action: simulationSettingsDropdownItems[0].action,
  },
  {
    title: 'Tools',
    subMenu: [
      {
        title: 'Image viewer (Ctrl+Shift+2)',
        action: imageViewerDropdownItems[0].action,
      },
      {
        title: '3D viewer',
        action: simulatorNavDropdownActions.open_3D_viewer,
      },
      {
        title: 'Isocenter',
        subMenu: [
          {
            title: ' Whole Body (Ctrl+Shift+3)',
            action: isocenterDropdownItems[0].action,
          },
          {
            title: 'Regions (Ctrl+Shift+4)',
            action: isocenterDropdownItems[1].action,
          },
        ],
      },
      {
        title: 'Display Options',
        subMenu: [
          {
            title: 'Show text on viewers',
            action: 'true',
            name: 'text_on_viewers',
            type: 'toggle',
            value: '1',
            configurationName: simulatorConfig.TEXT_ON_VIEWERS,
            toggleValues: ['0', '1'],
          },
          {
            title: 'Show intersections on active viewer',
            action: 'true',
            name: 'active_intersections',
            type: 'toggle',
            value: '1',
            configurationName: simulatorConfig.ACTIVE_INTERSECTIONS,
            toggleValues: ['0', '1'],
          },
          {
            title: 'Show tissues on hover (image viewer)',
            action: 'true',
            name: 'show_tissue_hover',
            type: 'toggle',
            value: '1',
            configurationName: simulatorConfig.SHOW_TISSUE_HOVER,
            toggleValues: ['0', '1'],
          },
          {
            title: 'Show ECG',
            action: 'true',
            name: 'ecgGraph',
            type: 'toggle',
            value: '1',
            configurationName: simulatorConfig.ECG_GRAPH,
            toggleValues: ['0', '1'],
          },
        ],
      },
    ],
  },
  {
    title: 'Preferences',
    subMenu: [
      {
        title: 'Units',
        subMenu: [
          {
            title: 'Distance',
            subMenu: [
              {
                title: 'mm',
                action: 'true',
                name: 'distance_unit__0.001',
                configurationName: simulatorConfig.DISTANCE_UNIT,
                value: '0.001',
              },
              {
                title: 'cm',
                action: 'true',
                name: 'distance_unit__0.01',
                configurationName: simulatorConfig.DISTANCE_UNIT,
                value: '0.01',
              },
              {
                title: 'm',
                action: 'true',
                name: 'distance_unit__1',
                configurationName: simulatorConfig.DISTANCE_UNIT,
                value: '1',
              },
            ],
          },
          {
            title: 'Time',
            subMenu: [
              {
                title: 'ms',
                action: 'true',
                name: 'time_unit__0.001',
                configurationName: simulatorConfig.TIME_UNIT,
                value: '0.001',
              },
              {
                title: 's',
                action: 'true',
                name: 'time_unit__1',
                configurationName: simulatorConfig.TIME_UNIT,
                value: '1',
              },
              {
                title: 'min',
                action: 'true',
                name: 'time_unit__60',
                configurationName: simulatorConfig.TIME_UNIT,
                value: '60',
              },
            ],
          },
        ],
      },
      {
        title: 'Advanced notifications',
        subMenu: [
          {
            title: 'Off',
            action: 'true',
            name: 'advanced_notifications__0',
            configurationName: simulatorConfig.ADVANCE_NOTIFICATIONS,
            value: '0',
          },
          {
            title: 'On',
            action: 'true',
            name: 'advanced_notifications__1',
            configurationName: simulatorConfig.ADVANCE_NOTIFICATIONS,
            value: '1',
          },
        ],
      },
    ],
  },
  {
    title: 'Notifications',
    action: notificationDropdownItems[0].action,
    name: 'notifications',
  },
  {
    title: 'Help',
    action: helpDropdownItems[0].action,
  },
];

export const lightSimulatorMenuItems: MenuItem[] = [];
